import { useState } from "react";
import { useGetReceivingDataAnalyticsQuery } from "../dashBoardApi";
import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";
import { getCurrentDate } from "../../../helpers/Utils";

const ReceivingAreaData = ({ startDate , endDate}) => {

  const [currentDate] = useState(getCurrentDate("YYYY-MM-DD"));
  const {
    data : receivingData ,
    isLoading : isReceivingDataLoading ,
    isFetching : isReceivingDataFetching,
    isError : isReceivingError  
  } = useGetReceivingDataAnalyticsQuery(
    {
      startDate,
      endDate
    },
    {
      skip: !startDate || !endDate // avoid API call if empty
    }
  );

  const respData = receivingData?.data; 

  
  const DUMMY = {
    total_cases_entered:  "12,480",
    total_accepted_cases: "11,902",
    total_rejected_cases: "578",
    total_accepted_kg:    "238,040 kg",
    total_rejected_kg:    "11,560 kg",
  };

  const boxes = [
    { key: "total_cases_entered",  label: "Case Entered"   },
    { key: "total_accepted_cases", label: "Case Accepted"  },
    { key: "total_rejected_cases", label: "Case Rejected"  },
    { key: "total_accepted_kg",    label: "Accepted KG"    },
    { key: "total_rejected_kg",    label: "Rejected KG"    },
  ];

  return (
    <DashboardCard
      title="Receiving Data"
      badgeIcon={startDate && endDate
        ? <span className="pko-batch-badge">{startDate} → {endDate}</span>
        : null
      }
    >
      <div className="fqm-grid">
        {boxes.map((b) => (
          <div key={b.key} className="pp-brokering-box fqm-box">
            <div className="pp-brokering-box-label">{b.label}</div>
            <div className="pp-brokering-box-value">
              {isReceivingDataLoading
                ? <span className="db-shimmer" style={{ height: 28, width: 60, display: "block" }} />
                : (respData?.[b.key] ?? "0")
              }
            </div>
          </div>
        ))}
      </div>
    </DashboardCard>
  );
};

export default ReceivingAreaData;
